import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AppContextProvider from "./AppContextProvider";
import { theme } from "./theme";

// Benign browser safety signal (often from MUI Dialog / layout thrash). CRA's
// error overlay treats it as fatal; ignore so it doesn't interrupt the UI.
const isResizeObserverLoopError = (message: unknown) =>
  typeof message === "string" &&
  (message.includes(
    "ResizeObserver loop completed with undelivered notifications"
  ) ||
    message.includes("ResizeObserver loop limit exceeded"));

window.addEventListener("error", (event) => {
  if (isResizeObserverLoopError(event.message)) {
    event.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <AppContextProvider>
        <App />
      </AppContextProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
